export default __webpack_public_path__ + "static/media/14.536c1335.jpg";